import { Feature, LineString } from "geojson";
import {
  buildDefaultCategories,
  CompositeCategory,
} from "../../../../survey/models/CompositeCategory";
import { categorizeCompositeFeature } from "../../../utils/query/categorizeCompositeFeature";

export function extractCompositeCategories(features: Feature<LineString>[]) {
  const totalFeaturesPerType: Record<string, number> = {};
  const classToTypes: Record<string, Set<string>> = {};

  const types: Set<string> = new Set();
  features.forEach((feature) => {
    const className = feature.properties!.class;
    const type = feature.properties!.type;
    classToTypes[className] = classToTypes[className] ?? new Set();
    classToTypes[className].add(type);
    types.add(type);

    totalFeaturesPerType[type] = (totalFeaturesPerType[type] ?? 0) + 1;
  });

  const allCategories = buildDefaultCategories();

  const categoriesByName = new Map<string, CompositeCategory>(
    allCategories.map((c) => [c.name, c]),
  );

  for (const [className, types] of Object.entries(classToTypes)) {
    for (const type of types) {
      var name = categorizeCompositeFeature(className, type);

      const totalFeatures = totalFeaturesPerType[type];

      const category = categoriesByName.get(name)!;
      category.totalFeatures += totalFeatures;
      category.items.push({ class: className, type: type });
    }
  }

  return [...categoriesByName.values()];
}
